import { Box, Column, Row } from '@stenajs-webui/core';
import { FlatButton, Icon, stenaArrowRightAngle, stenaMinusCircle } from '@stenajs-webui/elements';
import type { FC } from 'react';
import { useDispatch } from 'react-redux';
import { MAX_LENGTH_GOODS_WEIGHT } from '../../../common/fieldLengths';
import { trackEvent } from '../../../common/tracking/trackerService';
import { DetailsFieldCell } from '../../../common-ui/details/DetailsFieldCell';
import type { GoodsTypesQueryRefProps } from '../../../services/intermodal/hooks/useGoodsTypes';
import {
  removeUpdateIntermodalBookingGood,
  type UpdateIntermodalBookingGoodFormModel,
} from '../../../services/intermodal/updateIntermodalReducer';
import { UpdateGoodsTypeDropdown } from './fields/UpdateGoodsTypeDropdown';
import { UpdateGoodsWeightInput } from './fields/UpdateGoodsWeightInput';
import { UpdateIntermodalGoodsValidationWrapper } from './UpdateIntermodalValidationWrapper';

interface Props extends GoodsTypesQueryRefProps {
  editable: boolean;
  value: UpdateIntermodalBookingGoodFormModel;
}

export const UpdateBookingGoodsItem: FC<Props> = ({ value, editable, goodsTypesQueryRef }) => {
  const dispatch = useDispatch();
  return (
    <Column gap={2}>
      <UpdateIntermodalGoodsValidationWrapper
        name={'goodsType'}
        goodId={value.id}
        renderField={isValid => (
          <DetailsFieldCell
            label="Goods description"
            renderField={id => (
              <UpdateGoodsTypeDropdown
                id={id}
                isValid={isValid}
                goodsId={value.id}
                trackerCategory={'IntermodalUpdate'}
                goodsTypesQueryRef={goodsTypesQueryRef}
              />
            )}
          />
        )}
      />
      <UpdateIntermodalGoodsValidationWrapper
        name={'weight'}
        goodId={value.id}
        renderField={isValid => (
          <Row alignItems={'end'} gap>
            <Box style={{ paddingBottom: 6 }}>
              <Icon className={'bottom'} size={20} icon={stenaArrowRightAngle} />
            </Box>
            <DetailsFieldCell
              label={'Weight (kg)'}
              renderField={id => (
                <UpdateGoodsWeightInput
                  id={id}
                  goodsId={value.id}
                  maxLength={MAX_LENGTH_GOODS_WEIGHT}
                  isValid={isValid}
                  trackerCategory={'IntermodalUpdate'}
                />
              )}
              flex={1}
            />
            {editable ? (
              <FlatButton
                variant={'danger'}
                leftIcon={stenaMinusCircle}
                onClick={() => {
                  trackEvent({ category: 'IntermodalUpdate', action: 'Remove goods' });
                  dispatch(removeUpdateIntermodalBookingGood({ id: value.id }));
                }}
              />
            ) : null}
          </Row>
        )}
      />
    </Column>
  );
};
